import NotFoundScreen from '@screens/app/notFound'

export default NotFoundScreen
